import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import saveAs from 'file-saver';
import Button from '../buttons/Button';
import { getBlob } from '../utils/requests';

/**
 * File content
 * @module
 * @param {string} name - Name
 * @param {string} url - Url
 * @param {string} mineType - Mine type
 * @param {number} id - File ID
 * @param {object} [style] - Style object
 * @param {bool} [hideButton] - Hide button
 * @param {number} [imgWidth] - Image width
 * @param {number} [pdfWidth] - Pdf width
 * @param {number} [pdfHeight] - Pdf height
 */
const FileContent = (props) => {
  const [src, setSrc] = useState(null);
  const [data, setData] = useState(null);

  const init = useCallback(async () => {
    try {
      const data = await getBlob(props.url);

      if (props.mimeType === 'image/jpeg' || props.mimeType === 'image/png' || props.mimeType === 'image/gif' || props.mimeType === 'image/bmp') {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          setSrc(reader.result);
          setData(data);
        };
      } else if (props.mimeType === 'application/pdf' || props.mimeType === 'text/plain') {
        setSrc(URL.createObjectURL(data));
        setData(data);
      } else {
        setData(data);
      }
    } catch (error) {
      console.error(error);
      setData(null);
      setSrc(null);
    }
  }, [props.url, props.mimeType]);

  useEffect(() => {
    if (props.id) {
      init();
    }
    else {
      setData(null);
      setSrc(null);
    }
  }, [props.id, init]);

  const handleDownload = () => {
    saveAs(data, props.name);
  };

  const buildPreview = () => {
    if (!data) {
      return null;
    }

    switch (props.mimeType) {
      case 'application/pdf':
      case 'text/plain':
        return (
          <iframe
            src={src + '#toolbar=0&navpanes=0'}
            width={props.pdfWidth ? `${props.pdfWidth}%` : '100%'}
            height={props.pdfHeight ? props.pdfHeight : '100%'}
            title={props.name}
          />
        );
      case 'image/jpeg':
      case 'image/png':
      case 'image/gif':
      case 'image/bmp':
        return (
          <img
            width={props.imgWidth ? `${props.imgWidth}%` : 300}
            src={src}
            alt={props.name}
          />
        );
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return (
          <center>
            <div>
              <span className="k-icon k-i-word" style={{ fontSize: '64px' }}></span>
            </div>
            <div>nie je k dispozícii</div>
          </center>
        );
      case 'application/vnd.ms-excel':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return (
          <center>
            <div>
              <span className="k-icon k-i-excel" style={{ fontSize: '64px' }}></span>
            </div>
            <div>nie je k dispozícii</div>
          </center>
        );
      case 'text/xml':
      case 'application/xml':
      case 'application/x-eform-xml':
        return (
          <center>
            <div>
              <span className="k-icon k-i-txt" style={{ fontSize: '64px' }}></span>
            </div>
            <div>nie je k dispozícii</div>
          </center>
        );
      case 'application/x-zip-compressed':
        return (
          <center>
            <div>
              <span className="k-icon k-i-zip" style={{ fontSize: '64px' }}></span>
            </div>
            <div>nie je k dispozícii</div>
          </center>
        );
      default:
        return (
          <center>
            <div>
              <span className="k-icon k-i-file" style={{ fontSize: '64px' }}></span>
            </div>
            <div>nie je k dispozícii</div>
          </center>
        );
    }
  };

  const buildButton = () => {
    if (props.hideButton) {
      return null;
    }
    return (
      <Button
        label="Stiahnuť"
        primary={true}
        icon="download"
        onClick={handleDownload}
        disabled={!data || !props.id}
      />
    );
  };

  return (
    <>
      {buildPreview()}
      {buildButton()}
    </>
  );
}

FileContent.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  mimeType: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  style: PropTypes.object,
  hideButton: PropTypes.bool,
  imgWidth: PropTypes.number,
  pdfWidth: PropTypes.number,
  pdfHeight: PropTypes.number
}

export default FileContent;